<template>
  <el-dialog
    :title="dataType === 'sku' ? '选择sku' : '选择spu'"
    width="1089px"
    :visible="showModal"
    :close-on-click-modal="false"
    destroy-on-close
    @close="handleCancel"
  >
    <div class="selectSkuContent">
      <el-tabs v-model="activeTab">
        <el-tab-pane
          :label="dataType === 'sku' ? 'sku列表' : 'spu列表'"
          name="all"
        ></el-tab-pane>
        <el-tab-pane
          :label="'已选择商品' + '(' + selectList.length + '件' + ')'"
          name="selected"
        ></el-tab-pane>
      </el-tabs>
      <template v-if="activeTab == 'all'">
        <!-- 筛选部分 -->
        <div>
          <el-form
            inline
            :model="formData"
            ref="formData"
            label-width="85px"
            class="search-box new-input-box"
          >
            <el-form-item label="商品名称:">
              <el-input
                v-model="formData.itemName"
                placeholder="请输入商品名称"
                style="width: 260px"
              />
            </el-form-item>
            <el-form-item label="商品ID:">
              <el-input
                class="short-input"
                style="width: 260px"
                placeholder="请输入商品ID,多个ID用逗号分隔"
                size="small"
                v-model="formData.itemId"
              >
                <el-popover
                  v-model="itemIdPopoverVisible"
                  slot="suffix"
                  placement="bottom-start"
                  width="260"
                  popper-class="sku-popover"
                  trigger="click"
                  :append-to-body="false"
                >
                  <el-input
                    type="textarea"
                    v-model="formData.itemId"
                    :rows="5"
                    placeholder="请换行输入商品ID，至多可以输入3000个"
                  />
                  <div class="btnBox">
                    <el-upload
                      ref="uploadXls"
                      class="uploadFile"
                      action=""
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :limit="1"
                      :before-upload="beforeUploadXls"
                    >
                      <bi-button type="blueText">批量上传</bi-button>
                    </el-upload>

                    <bi-button type="blueText" @click="downloadTemplate"
                      >下载模板</bi-button
                    >
                    <bi-button type="blue" @click="itemIdPopoverVisible = false"
                      >完成</bi-button
                    >
                  </div>
                  <i
                    slot="reference"
                    style="color: #3159ff; cursor: pointer"
                    class="input_icon el-input__icon el-icon-tickets"
                  ></i>
                </el-popover>
              </el-input>
            </el-form-item>
            <el-form-item label="SKU ID:">
              <el-input
                class="short-input"
                style="width: 260px"
                placeholder="请输入SKU ID,多个ID用逗号分隔"
                size="small"
                v-model="formData.skuId"
              >
                <el-popover
                  v-model="skuIdPopoverVisible"
                  slot="suffix"
                  placement="bottom-start"
                  width="260"
                  popper-class="sku-popover"
                  trigger="click"
                  :append-to-body="false"
                >
                  <el-input
                    type="textarea"
                    v-model="formData.skuId"
                    :rows="5"
                    placeholder="请换行输入商品ID，至多可以输入3000个"
                  />
                  <div class="btnBox">
                    <el-upload
                      ref="uploadXls"
                      class="uploadFile"
                      action=""
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :limit="1"
                      :before-upload="beforeUploadXlsSkuId"
                    >
                      <bi-button type="blueText">批量上传</bi-button>
                    </el-upload>
                    <bi-button type="blueText" @click="downloadTemplate"
                      >下载模板</bi-button
                    >
                    <bi-button type="blue" @click="skuIdPopoverVisible = false"
                      >完成</bi-button
                    >
                  </div>

                  <i
                    slot="reference"
                    style="color: #3159ff; cursor: pointer"
                    class="input_icon el-input__icon el-icon-tickets"
                  ></i>
                </el-popover>
              </el-input>
            </el-form-item>
            <el-form-item label="指定品牌:">
              <el-select
                v-model="formData.brandId"
                placeholder="请选择"
                style="width: 260px"
              >
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in brandList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="商品状态:">
              <el-select v-model="formData.itemStatus" style="width: 260px">
                <el-option label="全部" value="" />
                <el-option label="上架" :value="0" />
                <el-option label="下架" :value="1" />
                <el-option label="删除" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="店铺类目:">
              <categoryCom
                v-model="formData.shopCategoryId"
                dataType="2"
                width="260"
                :platformCompanySellerId="subSystemSellerId"
                ref="platformCategoryComRef"
              >
              </categoryCom>
            </el-form-item>
            <el-form-item label="平台类目:">
              <categoryCom
                v-model="formData.categoryId"
                width="260"
                :platformCompanySellerId="subSystemSellerId"
                ref="platformCategoryComRef"
              >
              </categoryCom>
            </el-form-item>
            <el-form-item label="商品标签:">
              <productTagsCom
                v-model="formData.itemTagId"
                :platformCompanySellerId="subSystemSellerId"
                ref="productTagComRef"
              >
              </productTagsCom>
            </el-form-item>

            <el-form-item label=" " label-width="50px">
              <bi-button
                label="查询"
                @click="handleSearch"
                type="blue"
                :styleTextObj="{ marginRight: '8px' }"
              />
              <bi-button label="重置" @click="handleReset" type="gley" />
            </el-form-item>
          </el-form>
        </div>
        <div style="margin-top: 30px">
          <div class="ckecxBox">
            <el-checkbox v-model="checkAll" :disabled="checkCurrent" @change="handleCheckAll"
              >全选</el-checkbox
            >
            <el-checkbox v-model="checkCurrent" :disabled="checkAll" @change="handleCheckCurrent"
              >全选当前页</el-checkbox
            >
          </div>

          <div class="new-table-box" style="margin-top: 12px">
            <el-table
              ref="multipleTable"
              :data="tableData"
              :row-key="dataType === 'sku' ? 'skuId' : 'itemId'"
              :header-cell-style="{
                backgroundColor: '#F2F2F3',
                height: '48px',
                'line-height': '48px',
                overflow: 'auto',
                'font-weight': '700',
              }"
              max-height="490px"
              align="left"
              border
              v-loading="talbeLoading"
              @selection-change="handleSelectionChange"
            >
              <template slot="empty">
                <div>
                  <img src="@/assets/images/default/暂无任何数据.png" />
                  <span style="margin-left: -140px">暂无任何数据</span>
                </div>
              </template>
              <el-table-column
                type="selection"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="itemImage"
                label="商品信息"
                min-width="220"
              >
                <template #default="scope">
                  <div class="itemInfoBox">
                    <img
                      :src="
                        dataType === 'sku'
                          ? scope.row.skuImage
                          : scope.row.itemImage
                      "
                      alt=""
                      style="width: 28px; height: 28px"
                    />
                    <div class="itemInfoText">
                      {{
                        dataType === "sku"
                          ? scope.row.skuName
                          : scope.row.itemName
                      }}
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :prop="dataType === 'sku' ? 'skuId' : 'itemId'"
                :label="dataType === 'sku' ? 'skuId' : '商品Id'"
                min-width="120"
              >
              </el-table-column>

              <el-table-column
                prop="price"
                label="价格(元)"
                min-width="100"
                align="right"
              >
              </el-table-column>

              <el-table-column prop="itemStatus" label="商品状态" width="200">
                <template #default="scope">
                  <span>{{
                    scope.row.itemStatus === 0
                      ? "上架"
                      : scope.row.itemStatus === 1
                      ? "下架"
                      : "删除"
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="itemTags" label="商品标签" width="200">
                <template #default="scope">
                  <div>
                    <div
                      class="tagBoxs"
                      :style="
                        scope.row.tagsShow
                          ? 'flex-wrap: wrap;'
                          : 'flex-wrap: nowrap;'
                      "
                    >
                      <div
                        class="tagTip"
                        v-for="(item, index) in scope.row.itemTags"
                        :key="index"
                      >
                        {{ item.itemTagName || item.tagName }}
                      </div>
                    </div>
                    <div
                      class="moreTags"
                      v-if="scope.row.itemTags?.length > 0"
                      @click="$set(scope.row, 'tagsShow', !scope.row.tagsShow)"
                    >
                      <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="
                          scope.row.itemTags
                            .map((item) => item.itemTagName || item.tagName)
                            .join('、')
                        "
                        placement="top"
                      >
                        <div>
                          共{{
                            scope.row.itemTags ? scope.row.itemTags.length : 0
                          }}个标签
                          <i
                            v-if="!scope.row.tagsShow"
                            class="el-icon-arrow-down"
                            style="margin-left: 2px"
                          ></i>
                          <i
                            v-else
                            class="el-icon-arrow-up"
                            style="margin-left: 2px"
                          ></i>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="new-pagination-page">
            <el-pagination
              background
              style="text-align: right; padding: 20px 0 0 0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="formData.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="recordTotal"
              :current-page="formData.current"
            >
            </el-pagination>
          </div>
        </div>
      </template>
      <template v-if="activeTab == 'selected'">
        <div>
          <div>
            <bi-button type="text" @click="clearSelected">清空</bi-button>
          </div>
          <div class="new-table-box" style="margin-top: 12px">
            <el-table
              ref="selectedTable"
              :data="selectList"
              :row-key="dataType === 'sku' ? 'skuId' : 'itemId'"
              :header-cell-style="{
                backgroundColor: '#F2F2F3',
                height: '48px',
                'line-height': '48px',
                overflow: 'auto',
                'font-weight': '700',
              }"
              align="left"
              border
              max-height="490px"
            >
              <template slot="empty">
                <div>
                  <img src="@/assets/images/default/暂无任何数据.png" />
                  <span style="margin-left: -140px">暂无任何数据</span>
                </div>
              </template>
              <el-table-column
                prop="itemImage"
                label="商品信息"
                min-width="220"
              >
                <template #default="scope">
                  <div class="itemInfoBox">
                    <img
                      :src="
                        dataType === 'sku'
                          ? scope.row.skuImage
                          : scope.row.itemImage
                      "
                      alt=""
                      style="width: 28px; height: 28px"
                    />
                    <div class="itemInfoText">
                      {{
                        dataType === "sku"
                          ? scope.row.skuName
                          : scope.row.itemName
                      }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :prop="dataType === 'sku' ? 'skuId' : 'itemId'"
                :label="dataType === 'sku' ? 'skuId' : '商品Id'"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="price"
                label="价格(元)"
                min-width="100"
                align="right"
              >
              </el-table-column>
              <el-table-column prop="itemStatus" label="商品状态" width="200">
                <template #default="scope">
                  <span>{{
                    scope.row.itemStatus === 0
                      ? "上架"
                      : scope.row.itemStatus === 1
                      ? "下架"
                      : "删除"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="itemTags" label="商品标签" width="200">
                <template #default="scope">
                  <div>
                    <div
                      class="tagBoxs"
                      :style="
                        scope.row.tagsShow
                          ? 'flex-wrap: wrap;'
                          : 'flex-wrap: nowrap;'
                      "
                    >
                      <div
                        class="tagTip"
                        v-for="(item, index) in scope.row.itemTags"
                        :key="index"
                      >
                        {{ item.itemTagName || item.tagName }}
                      </div>
                    </div>
                    <div
                      class="moreTags"
                      v-if="scope.row.itemTags?.length > 0"
                      @click="$set(scope.row, 'tagsShow', !scope.row.tagsShow)"
                    >
                      <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="
                          scope.row.itemTags
                            .map((item) => item.itemTagName || item.tagName)
                            .join('、')
                        "
                        placement="top"
                      >
                        <div>
                          共{{
                            scope.row.itemTags ? scope.row.itemTags.length : 0
                          }}个标签
                          <i
                            v-if="!scope.row.tagsShow"
                            class="el-icon-arrow-down"
                            style="margin-left: 2px"
                          ></i>
                          <i
                            v-else
                            class="el-icon-arrow-up"
                            style="margin-left: 2px"
                          ></i>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="{ row, $index }">
                  <bi-button
                    type="blueText"
                    @click="handleRemoveSelected($index, row)"
                    >移除</bi-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </div>
    <template #footer>
      <div class="footerBtnBox">
        <bi-button @click="handleSure" type="blue">确定</bi-button>
        <bi-button @click="handleCancel" type="gley">取消</bi-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  getSkuList,
  getItemList,
  getBrandList,
  getIdsByFile,
} from "@/api/bi/selectProduct.js";
export default {
  name: "SelectSkuDialog",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    // 平台
    platformCode: {
      type: String,
      default: "",
    },
    // 店铺ID
    subSystemSellerId: {
      type: String,
      default: "",
    },
    // 用于回显选中的商品列表
    selectedProductList: {
      type: Array,
      default: () => [],
    },
    dataType: {
      type: String,
      default: "sku",
    },
  },
  data() {
    return {
      itemIdPopoverVisible: false,
      skuIdPopoverVisible: false,
      selectList: [],
      activeTab: "all",
      formData: {
        itemName: "", // 商品名称
        itemId: "", // 商品ID
        skuId: "", // SKU ID
        brandId: "", // 指定品牌
        itemStatus: "", // 商品状态
        categoryId: "", // 平台类目
        shopCategoryId: "", // 店铺类目
        itemTagId: "", // 商品标签
        size: 10,
        current: 1,
      },
      tableData: [],
      talbeLoading: false,
      recordTotal: 0,
      checkAll: false,
      checkCurrent: false,
      brandList: [],
      isSyncing: false,
    };
  },
  watch: {
    async showModal(newVal) {
      if (newVal) {
        this.brandList = []
        this.tableData = []

        await this.shopInfoBackFill();

        // 重置
        this.handleReset();
        this.getBrandListFn();

        // 回显选中的商品
        // this.selectList = JSON.parse(JSON.stringify(this.selectedProductList));
      }
    },
    subSystemSellerId(newVal, oldVal) {
      if (newVal != oldVal) {
        // 重置
        this.resetData();
      }
    },
    activeTab(newVal) {
      if (newVal === "all") {
        this.syncTableSelection();
      }
    },
  },
  methods: {
    async shopInfoBackFill() {
      try {
        this.talbeLoading = true;
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        const apiMethod = this.dataType === "sku" ? getSkuList : getItemList;
        const ids = (this.selectedProductList || []).map(item => item[idKey]);
        let params = {
          [idKey]: ids.join(','),
          platformCode: this.platformCode,
          subSystemSellerId: this.subSystemSellerId,
          current: 1,
          size: 10000,
        };
        let res = await apiMethod(params);
        if (res.code == 1 || res.code == 200) {
          const data = res.data ? res.data.records || [] : [];
          this.selectList = (this.selectedProductList || []).map(item1 => {
            return data.find(item2 => item2[idKey] == item1[idKey]) || JSON.parse(JSON.stringify(item1));
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.talbeLoading = false;
      }
    },
    async getproductFn(size = 0) {
      this.talbeLoading = true;
      try {
        const apiMethod = this.dataType === "sku" ? getSkuList : getItemList;
        let params = {
          ...this.formData,
          platformCode: this.platformCode,
          subSystemSellerId: this.subSystemSellerId,
        };
        if (size) {
          params.size = size;
        }
        this.isSyncing = true;
        let res = await apiMethod(params);
        if (res.code == 200 || res.code == 1) {
          this.tableData = res.data?.records || [];
          this.recordTotal = Number(res.data?.total || 0);
          this.syncTableSelection();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.talbeLoading = false;
      }
    },
    syncTableSelection() {
      this.$nextTick(() => {
        if (!this.$refs.multipleTable) return;
        this.isSyncing = true;
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        this.tableData.forEach((row) => {
          const isSelected = this.selectList.some(
            (item) => item[idKey] == row[idKey],
          );
          this.$refs.multipleTable.toggleRowSelection(row, isSelected);
        });
        // 恢复标志位
        this.$nextTick(() => {
          this.isSyncing = false;
        });
        this.syncCheckAll();
        this.syncCheckCurrent();
      });
    },
    async getBrandListFn() {
      try {
        let res = await getBrandList({
          platformCompanySellerId: this.subSystemSellerId,
        });
        if (res.code == 200 || res.code == 1) {
          this.brandList = res.data.map((item) => {
            return {
              label: item.pidName,
              value: item.brandId,
            };
          });
        }
      } finally {
      }
    },
    async handleCheckAll(val) {
      this.checkCurrent = false;
      if (val) {
        this.talbeLoading = true;
        try {
          const apiMethod = this.dataType === "sku" ? getSkuList : getItemList;
          let params = {
            ...this.formData,
            current: 1,
            platformCode: this.platformCode,
            subSystemSellerId: this.subSystemSellerId,
          };
          params.size = this.recordTotal;
          this.isSyncing = true;
          let res = await apiMethod(params);
          if (res.code == 200 || res.code == 1) {
            this.selectList = res.data?.records || [];
            this.syncTableSelection();
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.talbeLoading = false;
        }
      }else{
        this.selectList = [];
        this.syncTableSelection();
      }
    },
    syncCheckAll() {
      if (
        this.selectList.length > 0 &&
        this.selectList.length === this.recordTotal
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleCheckCurrent(val) {
      this.isSyncing = true;
      this.checkCurrent = val;
      this.checkAll = false;
      if(val){
        this.selectList = JSON.parse(JSON.stringify(this.tableData));
        if (this.$refs.multipleTable) {
          this.tableData.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row, val);
          });
          this.$nextTick(() => {
            this.isSyncing = false;
          });
        }
      }else{
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        this.tableData.forEach((row) => {
          const index = this.selectList.findIndex(item => item[idKey] == row[idKey]);
          if (index > -1) {
            this.selectList.splice(index, 1);
          }
        });
        this.syncTableSelection();
      }
    },
    clearSelected() {
      this.selectList = [];
      this.syncTableSelection();
    },
    downloadTemplate() {
      let url =
        "https://yunqi-dy-public.tos-cn-beijing.volces.com/templateDir/%E5%AF%BC%E5%85%A5%E5%95%86%E5%93%81%E6%A8%A1%E6%9D%BF.xlsx";
      let fileName = "sku上传模版.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    beforeUploadXls(file) {
      const fileSize = file.size / 1024 / 1024 < 2;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 2MB!");
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      forms.append("type", 2);
      getIdsByFile(forms).then((res) => {
        if (res.code == 200 || res.code == 1) {
          this.$message.success("上传成功");
          this.formData.itemId = res.data.join(",");
        } else {
          this.$message.error(res.message);
        }
      });
      return false;
    },
    beforeUploadXlsSkuId(file) {
      const fileSize = file.size / 1024 / 1024 < 2;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 2MB!");
        return false;
      }
      let forms = new FormData();
      forms.append("file", file);
      forms.append("type", 2);
      getIdsByFile(forms).then((res) => {
        if (res.code == 200 || res.code == 1) {
          this.$message.success("上传成功");
          this.formData.skuId = res.data.join(",");
        } else {
          this.$message.error(res.message);
        }
      });
      return false;
    },
    validNum(val) {
      console.log(val);
      this.formData.itemId = val.replace(/[^0-9,]+/g, "");
    },
    handleSelectionChange(val) {
      console.log("🚀 ~ this.isSyncing:", this.isSyncing)
      if (this.isSyncing) return;
      const idKey = this.dataType === "sku" ? "skuId" : "itemId";
      this.tableData.forEach((row) => {
        const index = this.selectList.findIndex(
          (item) => item[idKey] == row[idKey],
        );
        if (index > -1) {
          this.selectList.splice(index, 1);
        }
      });
      val.forEach((row) => {
        this.selectList.push(row);
      });
      this.syncCheckAll();
      this.syncCheckCurrent();
    },
    syncCheckCurrent() {
      if (this.checkAll) {
        this.checkCurrent = false;
        return;
      }
      if (this.tableData.length > 0 && this.selectList.length > 0) {
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        this.checkCurrent = this.tableData.every((row) =>
          this.selectList.some((item) => item[idKey] == row[idKey]),
        );
      } else {
        this.checkCurrent = false;
      }
    },
    handleSizeChange(val) {
      this.formData.size = val;
      this.getproductFn();
    },
    handleCurrentChange(val) {
      this.formData.current = val;
      this.getproductFn();
    },
    handleRemoveSelected(index, row) {
      this.selectList.splice(index, 1);
      if (this.$refs.multipleTable) {
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        const foundRow = this.tableData.find(
          (item) => item[idKey] == row[idKey],
        );
        if (foundRow) {
          this.isSyncing = true;
          this.$refs.multipleTable.toggleRowSelection(foundRow, false);
          this.$nextTick(() => {
            this.isSyncing = false;
          });
        }
      }
    },
    // 查询
    handleSearch() {
      this.getproductFn();
    },
    // 重置查询
    handleReset() {
      this.formData = this.$options.data.call(this).formData;
      this.getproductFn();
    },
    // 重置数据
    resetData() {
      this.checkAll = false;
      this.checkCurrent = false;
      this.selectList = [];
      this.tableData = [];
    },

    handleSure() {
      // 触发确定事件，并关闭弹窗
      this.$emit("update:showModal", false);
      this.$emit("confirm", this.selectList);
    },
    handleCancel() {
      // 触发取消事件，并关闭弹窗
      this.$emit("update:showModal", false);
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "@/views/prefabricateReport/style/contentbox.scss";
* {
  font-family: PingFang SC, PingFang SC;
}
.footerBtnBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.itemInfoBox {
  display: flex;
  align-items: center;
  gap: 8px;
  .itemInfoText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.selectSkuContent {
  :deep(.el-tabs__nav-wrap.el-tabs__nav-wrap::after) {
    background-color: transparent;
  }
  :deep(.inputBox),
  :deep(.product-tags-box) {
    .trigger-box {
      width: 260px;
    }
  }
}
.ckecxBox {
  display: flex;
  align-items: center;
  :deep(.el-checkbox) {
    margin-right: 18px;
  }
  :deep(.el-checkbox__label) {
    color: #666666 !important;
    padding-left: 6px;
  }
}
.new-table-box {
  :deep(.el-table--enable-row-transition .el-table__body td) {
    min-height: 40px !important;
  }
  :deep(.el-table--enable-row-transition .el-table__body td) {
    height: 40px !important;
  }
  :deep(.el-table--small td) {
    padding: 0 !important;
  }
}
.search-box {
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 0;
  ::v-deep .el-form-item {
    display: flex;
    margin: 0;
  }
  ::v-deep .el-form-item__content {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    margin: 0;
    padding: 0;
  }
}
.new-input-box {
  background-color: transparent;
  :deep(.el-form-item__label) {
    color: #666666 !important;
  }
}
.short-input {
  :deep(.el-input__inner) {
    padding-right: 30px !important;
  }

  :deep(.sku-popover) {
    padding: 4px;
    margin-left: -230px !important;
    background-color: #f5f5f7;
    .popper__arrow {
      left: 242px !important;
    }
    .el-textarea__inner {
      background-color: #fff !important;
      border-radius: 2px;
      border: 1px solid transparent !important;
    }
  }
}
.btnBox {
  padding-top: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  :deep(.bi-button-box .line-height-box) {
    line-height: 1.5;
  }
  :deep(.bi-button-box .new-btn) {
    font-size: 12px !important;
  }
  :deep(.bi-button-box .min-width) {
    min-width: 40px !important;
  }
}

.tagBoxs {
  display: flex;
  gap: 4px;
  overflow: hidden;
  max-width: 100%;
  margin-top: 10px;
}
.tagTip {
  background: #f5f5f5;
  border-radius: 2px;
  padding: 2px 6px;
  font-size: 14px;
  color: #666;
  line-height: 18px;
  white-space: nowrap;
}
.moreTags {
  font-size: 12px;
  color: #999;
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
